import { render, staticRenderFns } from "./pc-layout.vue?vue&type=template&id=3b93ed22&"
import script from "./pc-layout.vue?vue&type=script&lang=js&"
export * from "./pc-layout.vue?vue&type=script&lang=js&"
import style0 from "./pc-layout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports